module.exports = __webpack_public_path__ + "img/slide-2-ua.400c285c.png";